import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [userId, setUserId] = useState(localStorage.getItem("geniusBabySiteUserId") || null);
    const [user, setUser] = useState(localStorage.getItem("geniusBabySiteUserName") || null);
    const [email, setEmail] = useState(localStorage.getItem("geniusBabySiteUserEmail") || null);
    const [contact, setContact] = useState(localStorage.getItem("geniusBabySiteUserContact") || null);
    const [role, setRole] = useState(localStorage.getItem("geniusBabySiteUserRole") || null);
    const [token, setToken] = useState(localStorage.getItem("geniusBabySite") || "");
    const navigate = useNavigate();

    const loginAction = async (data) => {
        try {
            const response = await fetch(apiBaseUrl + "/auth/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            const res = await response.json();
            if (res) {
                if (res.status === 200) {

                    setUserId(res.result.userId);
                    setUser(res.result.username);
                    setEmail(res.result.email);
                    setContact(res.result.contact);
                    setRole(res.result.role);
                    setToken(res.token);
                    localStorage.setItem("geniusBabySiteUserId", res.result.userId);
                    localStorage.setItem("geniusBabySiteUserName", res.result.username);
                    localStorage.setItem("geniusBabySiteUserEmail", res.result.email);
                    localStorage.setItem("geniusBabySiteUserContact", res.result.contact);
                    localStorage.setItem("geniusBabySiteUserRole", res.result.role);
                    localStorage.setItem("geniusBabySite", res.token);
                    //navigate("/dashboard");

                }
                return res;
                // else {
                //     alert(res.detail);
                //     return res;
                // }
            }
            throw new Error(res.detail);
        } catch (err) {
            console.error(err);
        }
    };

    const logOut = () => {
        console.log("logout called");
        setUserId(null);
        setUser(null);
        setEmail(null);
        setContact(null);
        setRole(null);
        setToken("");
        localStorage.removeItem("geniusBabySiteUserId");
        localStorage.removeItem("geniusBabySiteUserName");
        localStorage.removeItem("geniusBabySiteUserEmail");
        localStorage.removeItem("geniusBabySiteUserContact");
        localStorage.removeItem("geniusBabySiteUserRole");
        localStorage.removeItem("geniusBabySite");
        navigate("/login");
    };

    return (
        <AuthContext.Provider value={{ token, userId, user, email, contact, role, loginAction, logOut }}>
            {children}
        </AuthContext.Provider>
    );

};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};